import { Response, apiAbortController } from '@ui/src';
import api from '../../../api/api';
import { CurrencyItem } from '../types';

export interface CurrencyBody {
  code: number;
  name: string;
  description: string;
  decimals: number;
}

export const currenciesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getConfigurationCurrencies: build.query<Response<CurrencyItem>, string>({
      query: (cursor) => ({
        url: `/v1/currencies${cursor}&active=true`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getConfigurationCurrency: build.query<{ data: CurrencyItem }, string>({
      query: (id) => ({
        url: `/v1/currencies/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    toggleConfigurationCurrenciesActive: build.mutation<
      {
        data: CurrencyItem;
      },
      { active: boolean; id: string }
    >({
      query: (data: { active: boolean; id: string }) => ({
        url: `/v1/currencies/${data.id}/active`,
        method: 'PUT',
        body: {
          active: data.active,
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    createCurrency: build.mutation<
      {
        data: CurrencyItem;
      },
      CurrencyBody
    >({
      query: (body) => ({
        url: '/v1/currencies',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useGetConfigurationCurrenciesQuery,
  useLazyGetConfigurationCurrenciesQuery,
  useGetConfigurationCurrencyQuery,
  useLazyGetConfigurationCurrencyQuery,
  useToggleConfigurationCurrenciesActiveMutation,
  useCreateCurrencyMutation,
} = currenciesApi;

export const {
  endpoints: {
    getConfigurationCurrencies,
    getConfigurationCurrency,
    toggleConfigurationCurrenciesActive,
    createCurrency,
  },
} = currenciesApi;
